<template>
    <page-header-wrapper>
        <template slot="extra">
            <workbench-tab @change="getTabId" v-model="active"></workbench-tab>
        </template>
        <a-card :bordered="false">
            <div class="table-page-search-wrapper" v-action:query>
                <a-form layout="inline">
                    <a-row :gutter="6">
                        <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8" :xxl="6">
                            <a-form-item label="时间筛选：">
                                <a-range-picker @change="getDate" v-model="queryParam.time" style="width:220px" />
                            </a-form-item>
                        </a-col>
                        <!-- <a-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" :xxl="4">
                            <a-form-item label="来源">
                                <a-select v-model="queryParam.dataSource" placeholder="请选择" default-value="0" style="width:100px">
                                <a-select-option value="0">全部</a-select-option>
                                <a-select-option value="3">网厅</a-select-option>
                                <a-select-option value="2">微信</a-select-option>
                                </a-select>
                            </a-form-item>
                            </a-col> -->
                        <a-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" :xxl="4">
                            <a-form-item label="状态">
                                <a-select v-model="queryParam.auditStatus" placeholder="请选择" default-value="0"
                                    @change="getStatus" style="width:120px">
                                    <a-select-option :value="index" v-for="(item, index) in statusMap"
                                        :key="index">{{ item.text }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xs="24" :sm="24" :md="13" :lg="13" :xl="9" :xxl="7">
                            <a-form-item label="单位名称">
                                <a-input style="max-width: 220px;" placeholder="请输入" v-model="queryParam.keyword" />
                            </a-form-item>
                        </a-col>
                        <a-col :xs="24" :sm="24" :md="4" :lg="4" :xl="3" :xxl="3">
                            <span class="table-page-search-submitButtons"
                                :style="advanced && { float: 'right', overflow: 'hidden' } || {}">
                                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                                <a-button style="margin-left: 8px" @click="reset">重置</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>

            <s-table ref="table" size="default" :rowKey="(record) => record.id" :columns="columns" :data="loadData"
                showPagination="auto" :scroll="{ x: '1600px' }" :pageNum="pageNum">
                <span slot="serial" slot-scope="text, record, index">
                    {{ index + 1 }}
                </span>
                <span slot="source" slot-scope="data_source">
                    <a-tag :color="getSource(data_source).color">{{ getSource(data_source).name }}</a-tag>
                </span>
                <span slot="status" slot-scope="audit_status">
                    <a-badge class="badge0" status="default" text="全部" v-if="audit_status == 0" />
                    <a-badge class="badge1" status="default" text="待审核" v-else-if="audit_status == 1" />
                    <a-badge class="badge2" status="default" text="审核通过" v-else-if="audit_status == 2" />
                    <a-badge class="badge3" status="default" text="审核拒绝" v-else-if="audit_status == 3" />
                </span>
                <span slot="infoInfo" slot-scope="record">
                    <span>{{ record.life_total_num | showInfo }}</span>
                </span>
                <span slot="address" slot-scope="cell_name">
                    <ellipsis :length="20" tooltip class="ellip">
                        {{ cell_name }}
                    </ellipsis>
                </span>
                <span slot="time" slot-scope="update_time">
                    {{ update_time | time }}
                </span>
                <span slot="action" slot-scope="text, record">
                    <template>
                        <template v-if="record.audit_status == 1">
                            <span v-action:audit class="btn_pass" @click="handleEdit(record, 2)">通过</span>
                            <span v-action:audit class="btn_reject" @click="handleEdit(record, 3)">拒绝</span>
                        </template>
                        <span v-action:view class="btn_btn" @click="handleWatch(record)">详情</span>
                        <a-tooltip v-if="record.audit_status == 3">
                            <template slot="title">
                                {{ record.audit_opinion }}
                            </template>
                            <span class="btn_btn">拒绝理由</span>
                        </a-tooltip>
                    </template>
                </span>
            </s-table>

            <!-- 详情 -->
            <a-drawer class="myDrawer" title="业务办理详情" width="500px" placement="right" :visible="visible"
                @close="onClose">
                <div class="drawer_main">
                    <div class="drawer_main_title">{{ $sys.basic }}</div>
                    <div class="drawer_main_content">
                        <div class="drawer_main_item">
                            <div class="drawer_main_item_l">客户名称</div>
                            <div class="drawer_main_item_r">{{ info && info.company_name || '-' }}</div>
                        </div>
                        <div class="drawer_main_item">
                            <div class="drawer_main_item_l">{{ $sys.communityInfo }}</div>
                            <div class="drawer_main_item_r">{{ info && info.cell_name || '-' }}</div>
                        </div>
                        <div class="drawer_main_item">
                            <div class="drawer_main_item_l">现总表</div>
                            <div class="drawer_main_item_r">{{ info && info.now_sum_table || '-' }}</div>
                        </div>
                        <div class="drawer_main_item">
                            <div class="drawer_main_item_l">小区生活用水总户数</div>
                            <div class="drawer_main_item_r">{{ info && info.life_total_num | showInfo }}</div>
                        </div>
                        <div class="drawer_main_item">
                            <div class="drawer_main_item_l">联系人</div>
                            <div class="drawer_main_item_r">{{ info && info.name || '-' }}</div>
                        </div>
                        <div class="drawer_main_item">
                            <div class="drawer_main_item_l">联系电话</div>
                            <div class="drawer_main_item_r">{{ info && info.mobile || '-' }}</div>
                        </div>
                        <div class="drawer_main_item">
                            <div class="drawer_main_item_l">审核状态</div>
                            <div class="drawer_main_item_r a_pass" v-if="info && info.audit_status == 2">审核通过</div>
                            <div class="drawer_main_item_r a_reject" v-else-if="info && info.audit_status == 3">审核拒绝</div>
                            <div class="drawer_main_item_r" v-else>-</div>
                        </div>
                        <div class="drawer_main_item" v-if="info && info.audit_status == 3">
                            <div class="drawer_main_item_l">{{ $sys.auditReason }}</div>
                            <div class="drawer_main_item_r">{{ info && info.audit_opinion || '-' }}</div>
                        </div>
                    </div>
                    <div class="drawer_main_title">上传附件</div>
                    <div class="drawer_main_content">
                        <div v-if="attachment && attachment['0-0']">
                            <div class="drawer_main_item">
                                <div class="drawer_main_item_l">整体水表出户综合登记表</div>
                                <div class="drawer_main_item_r imgList">
                                    <div class="imgListContainer">
                                        <img :src="checkPrefixWithHttp(attachment['0-0']) ? attachment['0-0'] : prefix + attachment['0-0']"
                                            preview="1" preview-text="" v-if="attachment['0-0'] != 'null'">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </a-drawer>
            <!-- 理由 -->
            <a-modal class="modal_foot_center" v-model="modalVisible" title="理由" centered @ok="closeModal(1)"
                @cancel="closeModal(0)">
                <div>
                    <a-textarea placeholder="请输入回复内容" :rows="6" v-model="reason" />
                </div>
            </a-modal>
        </a-card>
        <iframe id="frame" :src="iframeUrl" frameborder="0" ref="iframe" style="display:none"></iframe>
    </page-header-wrapper>
</template>

<script>
import moment from 'moment'
import {
    getUrlKey
} from '@/utils'
import {
    Modal,
    message
} from 'ant-design-vue'
import {
    STable,
    Ellipsis
} from '@/components'
import {
    waterOutReformList,
    waterOutReformInfo,
    handleWaterOutReform
} from '@/api/service'
import workbenchTab from './workbenchTab'
import {
    prefix,
    getSource,
    checkPrefixWithHttp
} from '@/utils'
const columns = [{
    title: '序号',
    scopedSlots: {
        customRender: 'serial'
    },
    width: '90px',
    align: 'center'
},
{
    title: '数据来源',
    dataIndex: 'data_source',
    scopedSlots: {
        customRender: 'source'
    },
    align: 'center',
    width: '100px'
},
{
    title: '状态',
    dataIndex: 'audit_status',
    scopedSlots: {
        customRender: 'status'
    },
    align: 'center',
    width: '120px'
},
{
    title: '客户名称',
    dataIndex: 'company_name',
    align: 'center',
    width: '180px'
},
{
    title: '小区名称地址',
    dataIndex: 'cell_name',
    scopedSlots: {
        customRender: 'address'
    },
    align: 'center',
    width: '200px'
},
{
    title: '现总表',
    dataIndex: 'now_sum_table',
    align: 'center',
    width: '140px'
},
{
    title: '小区生活用水总户数',
    dataIndex: '',
    scopedSlots: {
        customRender: 'infoInfo'
    },
    align: 'center',
    width: '190px'
},
{
    title: '联系电话',
    dataIndex: 'mobile',
    align: 'center',
    width: '145px'
},
{
    title: '提交时间',
    dataIndex: 'create_time',
    scopedSlots: {
        customRender: 'time'
    },
    align: 'center',
    width: '180px'
},
{
    title: '操作',
    dataIndex: 'action',
    width: '220px',
    scopedSlots: {
        customRender: 'action'
    },
    align: 'center'
}
]

const statusMap = {
    0: {
        status: 'default',
        text: '全部'
    },
    1: {
        status: 'default',
        text: '待审核'
    },
    2: {
        status: 'success',
        text: '审核通过'
    },
    3: {
        status: 'error',
        text: '审核拒绝'
    },
    4: {
        status: 'success',
        text: '正在勘查'
    },
    5: {
        status: 'success',
        text: '方案确认中(红线内)'
    },
    6: {
        status: 'success',
        text: '正在施工'
    },
    7: {
        status: 'success',
        text: '已接入挂表'
    },
}

export default {
    name: '',
    components: {
        STable,
        Ellipsis,
        workbenchTab
    },
    data() {
        this.columns = columns
        return {
            // create model
            visible: false,
            advanced: false,
            // 查询参数
            queryParam: {
                time: [],
                auditStatus: '0',
                keyword: '',
                keyType: '3',
                startTime: '',
                endTime: '',
                worker: '',
                dataSource: '0'
            },
            // 加载数据方法 必须为 Promise 对象
            loadData: parameter => {
                const requestParameters = Object.assign({}, parameter, this.queryParam)
                return waterOutReformList(requestParameters)
                    .then(res => {
                        return res.data
                    })
            },
            active: 0,
            photo1: [],
            photo2: [],
            photo3: [],
            photo4: [],
            modalVisible: false, //回复弹窗
            reason: '', //审核理由
            statusMap: statusMap,
            info: '', //详情
            id: '', //列表id
            status: '', //2 通过  3 拒绝
            isChecked: false,
            prefix: prefix,
            pageNum: 0,
            iframeUrl: '',
            text: ['整体水表出户综合登记表'],
            attachment: null,
        }
    },
    filters: {
        time(t) {
            if (t) {
                return moment(parseInt(t) * 1000).format('YYYY/MM/DD HH:mm:ss')
            } else {
                return t
            }
        },
        statusFilter(type) {
            console.log(type);
            return statusMap[type].text
        }
    },
    created() {
        this.pageNum = Number(getUrlKey('p') || 0)
    },
    methods: {
        checkPrefixWithHttp: checkPrefixWithHttp,
        getSource: getSource,
        reply() { //回复弹窗打开
            this.modalVisible = true;
        },
        closeModal(status) { //回复弹窗关闭 1确定 2取消
            let that = this
            let reason = this.reason
            let params = {
                auditOpinion: reason,
                id: this.id,
                auditStatus: 3
            }
            if (status == 1) {
                if (!reason) {
                    this.$message.error('请输入拒绝理由')
                    return false
                }
                Modal.confirm({
                    content: '确认拒绝吗?',
                    onOk() {
                        handleWaterOutReform(params).then(res => {
                            if (res.code == 200) {
                                message.success('处理成功')
                                that.visible = false
                                that.$refs.table.refresh()
                                that.reason = ''
                                that.id = ''
                                that.status = ''
                                that.modalVisible = false;
                            } else {
                                message.error(res.msg)
                            }
                        })
                    },
                    onCancel() {
                        that.modalVisible = false
                    }
                })
            }
        },
        getTabId(e) {
            if (e == 0) {
                this.queryParam.worker = '';
            } else if (e == 1) {
                this.queryParam.worker = 'A';
            } else if (e == 2) {
                this.queryParam.worker = 'B';
            }
            this.$refs.table.refresh(true)
        },
        getDate(date, dateString) { //时间筛选
            this.queryParam.time = dateString
            this.queryParam.startTime = this.queryParam.time[0] ? this.queryParam.time[0] + ' 00:00:00' : ''
            this.queryParam.endTime = this.queryParam.time[1] ? this.queryParam.time[1] + ' 23:59:59' : ''
        },
        getStatus(e) {
            console.log('e', e);
            this.auditStatus = e;
        },
        reset() { //重置
            this.queryParam.time = null
            this.queryParam.startTime = ''
            this.queryParam.endTime = ''
            this.queryParam.auditStatus = '0'
            this.queryParam.keyword = ''
            this.queryParam.keyType = '3'
            this.queryParam.dataSource = '0'
            this.$refs.table.refresh(true)
        },
        handleEdit(record, status) { //处理
            this.id = record.id
            this.onClose(status);
        },
        handleWatch(record) {
            this.id = record.id
            this.getDetail(record.id)
            this.isChecked = true;
            this.visible = true
        },
        handlePre(record) { //预览
            let url = this.prefix + '/public/admin/h5/transfer_personal.html?id=' + record.id + '&token=' + localStorage
                .getItem('Access-Token')
            window.open(url);
        },
        getDetail(id) { //详情
            let params = {
                id: id
            }
            waterOutReformInfo(params).then(res => {
                if (res.code == 200) {
                    this.info = res.data
                    let attachment = res.data.attachment
                    this.attachment = attachment;
                    this.$previewRefresh()
                } else {
                    message.error(res.msg)
                }
            })
        },
        onClose(status) { //关闭右侧弹出层   2 通过  3 拒绝
            if (status == 2) {
                let that = this
                let reason = this.reason
                let params = {
                    auditOpinion: reason,
                    id: this.id,
                    auditStatus: 2
                }
                Modal.confirm({
                    content: '确认通过吗?',
                    onOk() {
                        handleWaterOutReform(params).then(res => {
                            if (res.code == 200) {
                                message.success('处理成功')
                                that.visible = false
                                that.$refs.table.refresh()
                                that.reason = ''
                                that.id = ''
                                that.status = ''
                                that.modalVisible = false;
                            } else {
                                message.error(res.msg)
                            }
                        })
                    },
                    onCancel() {
                        that.modalVisible = false
                    }
                })
            } else if (status == 3) {
                this.modalVisible = true;
            } else {
                this.visible = false
            }
        }
    },
    filters: {
        showInfo(str) {
            if (str) {
                let arr = str.split(',');
                return '楼房户数' + arr[0] + ',小区楼房' + arr[1] + '栋' + ',平房户数' + arr[2] + ',最高层数' + arr[3] + '层'
            } else {
                return str
            }
        },
        time(t) {
            if (t) {
                return moment(parseInt(t) * 1000).format('YYYY/MM/DD HH:mm:mm')
            } else {
                return t
            }
        },
    }
}
</script>
